/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Wild_Bullock_BlinkInputs */

const en_zesty_wild_bullock_blink = /** @type {(inputs: Zesty_Wild_Bullock_BlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments`)
};

const de_zesty_wild_bullock_blink = /** @type {(inputs: Zesty_Wild_Bullock_BlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare`)
};

/**
* | output |
* | --- |
* | "Comments" |
*
* @param {Zesty_Wild_Bullock_BlinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const zesty_wild_bullock_blink = /** @type {((inputs?: Zesty_Wild_Bullock_BlinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Wild_Bullock_BlinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zesty_wild_bullock_blink(inputs)
	return de_zesty_wild_bullock_blink(inputs)
});